import { API_URL } from '@moxie/constants';
import { IResponse, ProductType } from '@shared-components/models';
import axios from './axios';
import crmAxios from './crm-api-axios';

// const getProductTypeByServiceId = async (
//   id: string,
//   params = ''
// ): Promise<IResponse> => {
//   return axios.get(`${API_URL.CRM_PRODUCT_TYPE_BY_SERVICE_ID}/${id}/${params}`);
// };

const getProductTypeByServiceId = async (serviceId : string): Promise<ProductType[]> => {
  const data = await crmAxios.get(`${API_URL.CRM_API_SERVICES}/${serviceId}`);
  return data?.data?.data?.productTypes;
};

const getProductSubTypes = async (id: string): Promise<IResponse> => {
  return axios.get(`${API_URL.CRM_PRODUCT_SUB_TYPES}/${id}`);
};

const fetchProductTypesWithSubTypes = async () => {
  const { data } =await axios.get<IResponse<ProductType[]>>(`${API_URL.CRM_PRODUCT_TYPE_WITH_SUB_TYPE}`)
  return data.data
}

export { getProductTypeByServiceId, getProductSubTypes, fetchProductTypesWithSubTypes };
